import React from 'react'
import { CCard, CCardBody, CCardGroup, CCol, CContainer, CImage, CRow } from '@coreui/react'
import logo from '../../assets/images/icons/logo100x100.png'
import argLogo from '../../assets/images/icons/arg_logo_white.png'
import { useSelector } from 'react-redux'
import { withRouter } from 'src/withRouter'
import { getMemberFullName } from 'src/util/modelUtil'

const AutoEnrollFinish = ({}) => {
  const member = useSelector((state) => state.members.autoEnrolled)

  if (!member) return
  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={6} className="mt-3 mb-3">
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <div className="text-center">
                    <h1>Nous y voilà !</h1>
                    <p className="text-medium-emphasis">
                      Cher(e) <b>{getMemberFullName(member)}</b>, merci de nous avoir rejoints.
                      <br /> Considérez d&apos;ores et déjà ce parti comme votre nième famille.
                      <br />
                      Nous vous encourageons cependant à visiter physiquement votre organe
                      d&apos;affectation ou l&apos;une de nos fédérations afin de vous munir de
                      votre de carte membre, identité que chacun de nous porte. <br />
                      En attendant, poursuivez votre navigation dans{' '}
                      <a href="https://ensemble.cd">le site d&apos;informations accessible ici</a>.
                    </p>
                  </div>
                  <div
                    className="text-white text-center bg-info py-5"
                    style={{
                      marginLeft: -40,
                      marginRight: -40,
                      marginBottom: -40,
                      borderBottomLeftRadius: 6,
                      borderBottomRightRadius: 6,
                    }}
                  >
                    <CImage src={logo} height={80} />
                    <br />
                    <br />
                    <p>
                      <b>Ensemble</b>, un nouveau Congo est possible !
                    </p>
                    <br />
                    <br />
                    <div style={{ position: 'absolute', bottom: 20, right: 20 }}>
                      <span style={{ fontStyle: 'italic' }}>Powered by </span>
                      <CImage src={argLogo} height={30} title="Argile Groupe, Kinshasa / RDC" />
                    </div>
                  </div>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default withRouter(AutoEnrollFinish)
